<template>
  <div class="general-information-form">

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="companyName" name="companyName" v-model="company.name" type="text" class="form-control">
              <label for="companyName">Company name</label>
            </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="shopUrl" name="shopUrl" v-model="company.shopUrl" type="text" class="form-control">
              <label for="shopUrl">Shop URL</label>
            </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="companyUrl" name="companyUrl" v-model="company.companyUrl" type="text" class="form-control">
              <label for="companyUrl">Company URL</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="shopCountry" name="shopCountry" v-model="company.shopCountry" type="text" class="form-control">
              <label for="shopCountry">Country of your Shop</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="industry" name="industry" v-model="company.industry" type="text" class="form-control">
              <label for="industry">Industry</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="language" name="language" v-model="company.language" type="text" class="form-control">
              <label for="language">Language</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="checkoutLanguage" name="checkoutLanguage" v-model="company.checkoutLanguage" type="text" class="form-control">
              <label for="checkoutLanguage">Checkout language</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="yearlyTurnover" name="yearlyTurnover" v-model="company.yearlyTurnover" type="text" class="form-control">
              <label for="yearlyTurnover">Your yearly turnover</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="averageTicketSize" name="averageTicketSize" v-model="company.averageTicketSize" type="text" class="form-control">
              <label for="averageTicketSize">Your average ticket size</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="streetAndNumber" name="streetAndNumber" v-model="company.streetAndNumber" type="text" class="form-control">
              <label for="streetAndNumber">Company Street &amp; Number</label>
            </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="zip" name="zip" v-model="company.zip" type="text" class="form-control">
              <label for="zip">ZIP</label>
            </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="city" name="city" v-model="company.city" type="text" class="form-control">
              <label for="city">Company city</label>
            </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="country" name="country" v-model="company.country" type="text" class="form-control">
              <label for="country">Company country</label>
            </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="state" name="state" v-model="company.state" type="text" class="form-control">
              <label for="state">State</label>
            </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="custom-file kp-file" v-file-input>
          <input type="file" class="custom-file-input" id="businessRegisration">
          <label class="custom-file-label" for="businessRegisration">
            <span class="file-placeholder">Upload your business registration</span>
            <span class="file-name-holder"></span>
          </label>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <div class="input-wrapper">
              <input v-floating-label id="vat" name="vat" v-model="company.vat" type="text" class="form-control">
              <label for="vat">VAT</label>
            </div>
        </div>
      </div>
    </div>

    <div class="text-right mt-20">
      <button class="btn" @click="next()">Next</button>
    </div>

  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'general-information-form',
  computed: {
    ...mapFields({
      company: 'company'
    })
  },
  methods: {
    next() {
      this.$emit('next')
    }
  }
}
</script>
